import { DependencyItemObject } from './dependency-item-object.model';

export abstract class TreeItemObject {
    private _name: string;
    private _type: string;
    private _version: string;
    private _children: Array<TreeItemObject>;
    private _dependencies: Array<DependencyItemObject>;


    constructor(name: string, type: string, version: string,
        dependencies: Array<DependencyItemObject>, children: Array<TreeItemObject>) {
        this._name = name;
        this._type = type;
        this._children = children;
        this._version = version;
        this._dependencies = dependencies;
    }

    public get name(): string {
        return this._name;
    }

    public get type(): string {
        return this._type;
    }

    public get dependencies(): Array<DependencyItemObject> {
        return this._dependencies;
    }

    public children(): Array<TreeItemObject> {
        if (this._children === undefined) {
            this._children = new Array();
        }
        return this._children;
    }

    public get version(): string {
        return this._version;
    }

    abstract get id(): string;

    abstract getLevel(): number;

    public hasDependencies(): boolean {
        return this._dependencies && this._dependencies.length > 0;
    }


}
